const getNestedProperty = (// Wondering if this function is still necessary with optional chaining being available now.
obj1, path, defaultValue)=>{
    if (!obj1 || !path) {
        return defaultValue || undefined;
    }
    const pathArray = path.split('.');
    const result = pathArray.reduce((obj, prop)=>{
        return obj && obj[prop] ? obj[prop] : null;
    }, obj1);
    return result || defaultValue || undefined;
};

export { getNestedProperty };
//# sourceMappingURL=get-nested-property.js.map
